import { Link } from "react-router-dom";

import { useLanguage } from "../../contexts/LanguageContext";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SEOHead from "../SEOHead/SEOHead";

import "./LegalPage.css";

const slugify = (value, index) =>
  `${index + 1}-${value}`
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const LegalPage = ({ kind, title, updatedAt, description, sections }) => {
  const { language } = useLanguage();
  const isSpanish = language === "es";
  const isPrivacy = kind === "privacy";
  const labels = isSpanish
    ? {
        eyebrow: "Snappin / Legal",
        contents: "En esta página",
        contactTitle: "¿Tenés una consulta sobre este documento?",
        contactBody:
          "Escribinos desde el formulario de contacto e indicá si tu solicitud está relacionada con privacidad, contenido o facturación.",
        contact: "Contactar a Snappin",
        other: isPrivacy ? "Ver Términos de Servicio" : "Ver Política de Privacidad",
      }
    : {
        eyebrow: "Snappin / Legal",
        contents: "On this page",
        contactTitle: "Have a question about this document?",
        contactBody:
          "Use our contact form and tell us whether your request concerns privacy, content, or billing.",
        contact: "Contact Snappin",
        other: isPrivacy ? "View Terms of Service" : "View Privacy Policy",
      };

  const sectionLinks = sections.map((section, index) => ({
    ...section,
    id: slugify(section.title, index),
  }));

  return (
    <div className="legal-page">
      <SEOHead
        title={`${title} | Snappin`}
        description={description}
        url={`${window.location.origin}/${kind}`}
        type="website"
      />
      <Header />
      <main>
        <header className="legal-hero">
          <div className="legal-shell">
            <p className="legal-eyebrow">{labels.eyebrow}</p>
            <h1>{title}</h1>
            <p className="legal-updated">{updatedAt}</p>
            <p className="legal-intro">{description}</p>
          </div>
        </header>

        <div className="legal-shell legal-layout">
          <aside className="legal-index" aria-label={labels.contents}>
            <p>{labels.contents}</p>
            <nav>
              {sectionLinks.map((section, index) => (
                <a href={`#${section.id}`} key={section.id}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {section.title}
                </a>
              ))}
            </nav>
          </aside>

          <article className="legal-document">
            {sectionLinks.map((section, index) => (
              <section id={section.id} className="legal-section" key={section.id}>
                <div className="legal-section-number">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <div>
                  <h2>{section.title}</h2>
                  <ul>
                    {section.content.map((item, itemIndex) => (
                      <li key={`${section.id}-${itemIndex}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              </section>
            ))}

            <section className="legal-contact-card">
              <p className="legal-eyebrow">Snappin Support</p>
              <h2>{labels.contactTitle}</h2>
              <p>{labels.contactBody}</p>
              <div>
                <Link className="legal-primary-link" to="/contact">
                  {labels.contact}
                </Link>
                <Link to={isPrivacy ? "/terms" : "/privacy"}>{labels.other}</Link>
              </div>
            </section>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
